/**
 * Language Flag component - shows country flag based on content language
 */

export const LanguageFlag = ({ language, size = 'sm', showLabel = false }) => {
  const flags = {
    fi: { emoji: '🇫🇮', label: 'Suomi' },
    en: { emoji: '🇬🇧', label: 'English' }
  };

  const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  const flag = flags[language] || flags.en;

  return (
    <span 
      className={`inline-flex items-center gap-1 ${sizeClasses[size]}`}
      title={flag.label}
    >
      <span role="img" aria-label={flag.label}>{flag.emoji}</span>
      {showLabel && <span className="text-xs text-muted-foreground">{flag.label}</span>}
    </span>
  );
};

export default LanguageFlag;
